export default (playerData, heading, isDiscontinuation) => {
  const c = {
    playerData,
    heading,
    isDiscontinuation
  }
  const init = () => {
    console.log(`build${heading.key}`, c);

    if (!c.playerData) {
      return;
    }

    const contestantSection = document.querySelector('.le-meditation');
    const cloneContestantSection = contestantSection.cloneNode(true);

    cloneContestantSection.querySelector('.c-race-header__ttl-sub .c-race-header__ttl-txt').textContent = c.heading.en;
    cloneContestantSection.querySelector('.c-race-header__ttl-main .c-race-header__ttl-txt').textContent = c.heading.ja;
    cloneContestantSection.querySelector('.c-race-header__ttl-date').remove();

    const playerListUl = cloneContestantSection.querySelector('.le-meditation-list__body');

    if (c.isDiscontinuation) {
      playerListUl.classList.add('is-discontinuation');
    }

    playerListUl.innerHTML = c.playerData;

    playerListUl.classList.remove('_skelton');
    playerListUl.removeAttribute('aria-hidden');

    contestantSection.parentElement.appendChild(cloneContestantSection)
  }

  init();
}
